var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 15.8334V4.16669C3.33334 2.78597 4.45263 1.66669 5.83334 1.66669H14.1667C15.5474 1.66669 16.6667 2.78598 16.6667 4.16669V13.3334M3.33334 15.8334C3.33334 17.2141 4.45263 18.3334 5.83334 18.3334H14.1667C15.5474 18.3334 16.6667 17.2141 16.6667 15.8334V13.3334M3.33334 15.8334C3.33334 14.4526 4.45263 13.3334 5.83334 13.3334H16.6667M10 6.3764L10.1842 6.19225C10.6926 5.68376 11.5171 5.68376 12.0256 6.19225C12.5341 6.70075 12.5341 7.52518 12.0256 8.03368L10.7366 9.32267C10.3298 9.72947 9.67024 9.72947 9.26344 9.32267L7.97444 8.03368C7.46595 7.52518 7.46595 6.70075 7.97444 6.19225C8.48294 5.68376 9.30737 5.68376 9.81587 6.19225L10 6.3764Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavLiked);
export default __webpack_public_path__ + "static/media/sidenav-liked.57970c286e28357046dac2b9bfd20571.svg";
export { ForwardRef as ReactComponent };